<template>
    <div title="0">
        <div class='loader loader4'>
            <div>
                <div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <div>
                                        <div>
                                            <div>
                                                <div></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {{message}}
    </div>
</template>

<script>
export default {
    props: ["message"]
}
</script>

<style scoped lang="less">
    @grey: rgba(0, 0, 0, .5);
    @blue: rgba(0, 0, 255, .5);

    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes rotate2 {
        0% {
            transform: rotate(0deg);
            border-top-color: @grey;
        }
        50% {
            transform: rotate(180deg);
            border-top-color: @blue;
        }
        100% {
            transform: rotate(360deg);
            border-top-color: @grey;
        }
    }

    * {
        box-sizing: border-box;
    }

    .loader {
        position: relative;
        margin: 25px auto;
        width: 150px;
        height: 150px;
        display: block;
        div {
            height: 100%;
        }
    }

    .loader4, .loader4 div {
        border-radius: 50%;
        padding: 8px;
        border: 2px solid transparent;
        animation: rotate linear 3.5s infinite;
        border-radius: 50%;
        padding: 4px;
        animation: rotate2 4s infinite linear;
    }

    div:hover {
        animation-play-state: paused;
    }

    .loader, .loader * {
        will-change: transform;
    }
</style>
